import uiCore = require("../core/uicore");

export class PageLeaveListener implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "crewpageleavelistener",
        Template: require("./empty.html"),
        AngularDependencies: [uiCore.ScopeDependency, uiCore.RootScopeDependency, uiCore.MdDialogDependency],
        Bindings: {
            haschanges: "&"
        }
    }

    constructor(...args: any[]) {
        this._locator = uiCore.DependencyLocator.Create(PageLeaveListener, args);
        var $rootScope = this._locator.getRootScopeDependency();
        this.stateChangedListener = $rootScope.$on("$stateChangeStart", this.onStateChange);
    }

    private stateChangedListener : any;

    private showAlert(title: string, content: string): ng.IPromise<any> {
        var $mdDialog = this._locator.getMdDialogDependency();
        var confirm = $mdDialog.alert()
        .title(title)
            .textContent(content)
        .ok('Ok');
        return $mdDialog.show(confirm)
    }

    private onStateChange = (event, _toState, _toParams, _fromState, _fromParams) => {
        if (this.privatehaschanges()) {
            event.preventDefault();
            this.showAlert("Changes detected", "Please save or discard the changes before continuing.");
        }
        else {
            // Clean up - unsubscribe the event handler
            this.stateChangedListener();
        }
    }

    private _locator: uiCore.DependencyLocator;

    public haschanges: () => boolean;

    private privatehaschanges() : boolean {
        if (this.haschanges) return this.haschanges();
        else return false;
    }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/crewpageleavelistener.ts